import NotificationSnackbar from "./notification-snackbar.vue";

const promise = new Promise(resolve => {
  vueApp.component('notification-snackbar', NotificationSnackbar);
  resolve();
});

window.pendingComponentLoads.push(promise);